export default {

	init() {

		// When the user scrolls down 50px from the top of the document, resize the header's font size
		window.onscroll = function() {scrollFunction()};
		const nav = document.getElementById('MainNavigation');
		const logo = document.getElementById('SiteLogo');

		function scrollFunction() {

			if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
				logo.classList.add('lg:w-20');
				logo.classList.add('w-20');
			} else {
				logo.classList.remove('lg:w-20');
				logo.classList.remove('w-20');
			}

		}

		// var windowsize = $(window).width();

		// if (windowsize > 719) {

		// 	$('.menu-item-has-children').map(function() {
		// 		var customWidth = $(this).width();
		// 		$(this).css("max-width", customWidth+32+'px');
		// 	});

		// }	

		// $(window).resize(function() {
		// 	windowsize = $(window).width();
		// 	if (windowsize > 719) {

		// 		$('.menu-item-has-children').map(function() {
		// 			var customWidth = $(this).width();
		// 			$(this).css("max-width", customWidth+32+'px');
		// 		});

		// 	}
		//   });	


		//   $('.menu-item-has-children > a').removeAttr("href");

		  $('#header-mobile .menu-item-has-children').on('click', (function(){
			$(this).toggleClass("active");
		  }));

	}

}
